/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "src/components";
import { t } from "@superset-ui/core";

import Label from "src/components/Label";
import Popover from "src/components/Popover";
import PopoverSection from "src/components/PopoverSection";
import ControlHeader from "../../../ControlHeader";
import SelectControl from "../../SelectControl";

const propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.object,
    animation: PropTypes.bool,
    choices: PropTypes.array,
};

const defaultProps = {
    onChange: () => {},
    animation: true,
    choices: [],
};

export default class OlSpatialControl extends React.Component {
    constructor(props) {
        super(props);
        const v = props.value || {};
        let defaultCol;
        if (props.choices.length > 0) {
            defaultCol = props.choices[0][0];
        }
        this.state = {
            latCol: v.latCol || defaultCol,
            lonCol: v.lonCol || defaultCol,
            value: null,
            errors: [],
        };
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.onChange();
    }

    onChange() {
        const value = {};
        const errors = [];
        const errMsg = t("Invalid lat/long configuration.");
        value.latCol = this.state.latCol;
        value.lonCol = this.state.lonCol;
        if (!value.lonCol || !value.latCol) {
            errors.push(errMsg);
        }
        this.setState({ value, errors });
        this.props.onChange(value, errors);
    }

    setType(type) {
        this.setState({ type }, this.onChange);
    }

    renderLabelContent() {
        if (this.state.errors.length > 0) {
            return "N/A";
        }
        return `${this.state.lonCol} | ${this.state.latCol}`;
    }

    renderSelect(name) {
        return (
            <SelectControl
                ariaLabel={name}
                name={name}
                choices={this.props.choices}
                value={this.state[name]}
                clearable={false}
                onChange={(value) => {
                    this.setState({ [name]: value }, this.onChange);
                }}
            />
        );
    }

    renderPopoverContent() {
        return (
            <div style={{ width: "300px" }}>
                <PopoverSection title={t("Longitude & latitude columns")}>
                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            {t("Longitude")}
                            {this.renderSelect("lonCol")}
                        </Col>
                        <Col xs={24} md={12}>
                            {t("latitude")}
                            {this.renderSelect("latCol")}
                        </Col>
                    </Row>
                </PopoverSection>
            </div>
        );
    }

    render() {
        return (
            <div>
                <ControlHeader {...this.props} />
                <Popover
                    content={this.renderPopoverContent()}
                    placement="topLeft" // so that popover doesn't move when label changes
                    trigger="click"
                >
                    <Label className="pointer">{this.renderLabelContent()}</Label>
                </Popover>
            </div>
        );
    }
}

OlSpatialControl.propTypes = propTypes;
OlSpatialControl.defaultProps = defaultProps;
